import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box className="slot-details-header">
        <Box className="slot-details-header-icon">
          <Skeleton variant="circle" width={48} height={48} />
        </Box>
        <Box className="slot-details-header-infos">
          <Box className="slot-details-header-label">
            <Skeleton variant="text" width="20%" />
          </Box>
          <Box className="slot-details-header-text">
            <Skeleton variant="text" width="80%" />
          </Box>
        </Box>
      </Box>
      <Box className="list-professionals-title" px={3} mb={2}>
        <Skeleton variant="text" width="80%" />
      </Box>
      <Box display="flex" alignItems="center" px={3} mb={3}>
        <Skeleton variant="circle" width={48} height={48} />
        <Box flexGrow={1} ml={1}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="20%" />
        </Box>
        <Box mx={1} borderRadius={4}>
          <Skeleton variant="rect" width={50} height={20} />
        </Box>
        <Skeleton variant="circle" width={24} height={24} />
      </Box>
    </Box>
  );
};

export default Loading;
